import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Component({
  selector: 'sales-ui-opportunity-notes',
  templateUrl: './opportunity-notes.component.html',
  styleUrls: ['./opportunity-notes.component.scss'],
  standalone: false,
})
export class OpportunityNotesComponent {
  private readonly currentNote$$ = new ReplaySubject<string>(1);
  protected currentNote$ = this.currentNote$$.asObservable();
  private readonly editable$$ = new ReplaySubject<boolean>(1);
  protected editable$ = this.editable$$.asObservable();
  private readonly inEditMode$$ = new BehaviorSubject<boolean>(false);
  protected inEditMode$ = this.inEditMode$$.asObservable();

  @Input() set note(currentNote: string) {
    this.currentNote$$.next(currentNote);
  }
  @Input() set editable(isEditable: boolean) {
    this.editable$$.next(isEditable);
  }
  @Input() loading: boolean;

  @Output() noteChanged: EventEmitter<string> = new EventEmitter();

  enterEditMode(): void {
    this.inEditMode$$.next(true);
  }

  save(newNote: string): void {
    this.currentNote$$.next(newNote);
    this.inEditMode$$.next(false);
    this.noteChanged.emit(newNote);
  }

  cancel(): void {
    this.inEditMode$$.next(false);
  }
}
